module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryBookJacket.92891987.jpg";